import { normalizeRateAuditSchema } from '../utils/rateAudits';
import { handleApiCalls } from './axiosInstance';

export const fetchRateAudit = async countryRateID => {
  const url = `${process.env.REACT_APP_HOST_API}rate-audits?rateId=${countryRateID}`;
  const response = await handleApiCalls('get', url);

  return normalizeRateAuditSchema(response.data);
};
